/**
 * Graphology Graph Generators
 * ============================
 *
 * Library endpoint.
 */
exports.classic = require('./classic');
exports.community = require('./community');
exports.random = require('./random');
exports.small = require('./small');
exports.social = require('./social');
